


import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
// Removed duplicate import of useTheme
import GrnPdfHeader from "../../components/documents/GrnPdfHeader";
import GrnPdfFooter from "../../components/documents/GrnPdfFooter";
import ViewDataGridPdf from "../../components/grid/ViewDataGridPdf";
import { ViewReturnNotePdfData } from "../../components/grid/GridDataPdf";
import GrnPdfNotes from "../../components/documents/GrnPdfNotes";
import GrnPdfSupplier from "../../components/documents/GrnPdfSupplier";
import GrnPdfInfo from "../../components/documents/GrnPdfInfo";
import { FormatDate } from "../../utils/common/DateUtils";
import { useTheme, ThemeProvider } from "@mui/material/styles";
import { lightTheme } from "../../assets/styles/Theme";
import { FormatDateYYYYMM } from "../../utils/common/DateUtils";
import { GenerateNoteNumber } from "../../utils/common/SupportingFunctions";
import { CON_NOTE_DELIVERY, CON_NOTE_REJECT, CON_NOTE_RETURN, CON_STATUS_RETURNAPPROVED } from "../../utils/sys/Constants";

import { useSelector } from "react-redux";
const cellStyleLabel = {
  border: "1px solid black",
  fontWeight: "bold",
  fontSize: 12,
  textAlign: "right",
  px: 1,
  py: 0.5,
  bgcolor: "white",

  color: "black",
};

const cellStyleValue = {
  border: "1px solid black",
  // backgroundColor: "#f3f3f3",
  fontSize: 12,
  px: 1,
  py: 0.5,
  textAlign: "right",
  bgcolor: "white",

  color: "black",
};
function ReturnNotePdfHistory({
  docType,
  grnHeader,
  selectedSupplier,
  grnDetailsForm,
  grnPaySummery,
  grnData,
  grnItems,
  grnCompany,
  grnReturns,
  returnedProducts,
  grnReturnList,
  grnReturnMaster,
  Returncal,
} = {}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const printRef = useRef();

  const handlePrint = () => {
    window.print();
  };
  const formatCurrency = (val) =>
    new Intl.NumberFormat("en-LK", {
      // style: "currency",
      // currency: "LKR",
      minimumFractionDigits: 2,
    }).format(Number(val || 0));

  const parseNumber = (value) => {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  // Get the latest return-master record (from grnReturnMaster or grnReturnList)
  const getLatestReturnMaster = () => {
    const returnMasterSource =
      Array.isArray(grnReturnMaster) && grnReturnMaster.length > 0
        ? grnReturnMaster
        : grnReturnList;

    if (!Array.isArray(returnMasterSource) || returnMasterSource.length === 0) {
      return null;
    }
    
      const approvedRecords = returnMasterSource.filter(
    (r) => String(r?.sts) === CON_STATUS_RETURNAPPROVED
  );
   if (approvedRecords.length === 0) return null;
    const sorted = [...returnMasterSource].sort((a, b) => {
      const dateA = new Date(a.endate || 0).getTime();
      const dateB = new Date(b.endate || 0).getTime();
      return dateB - dateA;
    });
    
    return sorted[0] || null;
  };

  const latestReturnMaster = getLatestReturnMaster();

  // Helper function to check if a value is NOT empty
  const hasValue = (value) => {
    return value !== null && value !== undefined && value !== "" && value !== "0.00";
  };

// Prefer props, but fall back to localStorage to support direct routing
const localReturned = (() => {
  try {
    return JSON.parse(localStorage.getItem("returnedProducts") || "[]");
  } catch (e) {
    return [];
  }
})();

returnedProducts = (Array.isArray(returnedProducts) && returnedProducts.length)
  ? returnedProducts
  : localReturned;

grnReturns = (Array.isArray(grnReturns) && grnReturns.length)
  ? grnReturns
  : (Array.isArray(grnReturnList) && grnReturnList.length && grnReturnList.some((row) => Number(row?.returnedqty || 0) > 0))
  ? grnReturnList
  : returnedProducts;
const latestReturncalEntry =
  Array.isArray(Returncal) && Returncal.length > 0
    ? Returncal[Returncal.length - 1]
    : null;

const returncalItems = Array.isArray(latestReturncalEntry?.grnReturnItems)
  ? latestReturncalEntry.grnReturnItems
  : [];

const filteredReturncalItems = returncalItems.filter(
  (item) => Number(item?.returnedqty || 0) > 0
);

const fallbackReturnRecords =
  Array.isArray(grnReturns) && grnReturns.length
    ? grnReturns
    : returnedProducts;

const resolvedReturnRecords =
  filteredReturncalItems.length > 0
    ? filteredReturncalItems
    : Array.isArray(fallbackReturnRecords)
    ? fallbackReturnRecords.filter((item) => Number(item?.returnedqty || 0) > 0)
    : [];

// When latestReturnMaster exists, show only the last return's lines (one row per product from latest return)
// Get ALL approved return master records (sts === "10")
const approvedReturnMasters = (() => {
  const source =
    Array.isArray(grnReturnMaster) && grnReturnMaster.length > 0
      ? grnReturnMaster
      : grnReturnList;
  return Array.isArray(source)
    ? source.filter((r) => String(r?.sts) === CON_STATUS_RETURNAPPROVED)
    : [];
})();

const approvedReturnCodes = new Set(
  approvedReturnMasters.map((r) => String(r.grnreturncode))
);

let resolvedReturnRecordsForDisplay = resolvedReturnRecords;

if (approvedReturnCodes.size > 0) {
  const byApprovedReturns = resolvedReturnRecords.filter((r) =>
    approvedReturnCodes.has(String(r?.grnreturncode))
  );

  if (byApprovedReturns.length > 0) {
    // Aggregate returnedqty per product across all approved returns
    const qtyByProduct = new Map();
    byApprovedReturns.forEach((r) => {
      const key = String(r?.supproductcode ?? r?.productcode ?? "");
      if (!key) return;
      if (qtyByProduct.has(key)) {
        const existing = qtyByProduct.get(key);
        existing.returnedqty =
          Number(existing.returnedqty || 0) + Number(r?.returnedqty || 0);
      } else {
        qtyByProduct.set(key, { ...r });
      }
    });
    resolvedReturnRecordsForDisplay = Array.from(qtyByProduct.values());
  }
}

const grnProductsList = Array.isArray(grnItems) && grnItems.length
  ? grnItems
  : Array.isArray(grnData)
  ? grnData
  : [];

const productLookupByProductCode = new Map();
const productLookupBySuppCode = new Map();

grnProductsList.forEach((product) => {
  if (product?.productcode !== undefined && product?.productcode !== null) {
    productLookupByProductCode.set(String(product.productcode), product);
  }
  if (product?.supproductcode !== undefined && product?.supproductcode !== null) {
    productLookupBySuppCode.set(String(product.supproductcode), product);
  }
});
console.log("Product Lookup Maps:",resolvedReturnRecordsForDisplay)


const grnItemsRows = resolvedReturnRecordsForDisplay.map((item, index) => {
  const candidateCodes = [
    item?.productcode,
    item?.supproductcode,
    item?.grnprcode,
  ]
    .map((code) => (code === null || code === undefined ? "" : String(code)))
    .filter(Boolean);

  let matchedProduct = null;
  for (const code of candidateCodes) {
    if (!code) continue;
    matchedProduct =
      productLookupByProductCode.get(code) ||
      productLookupBySuppCode.get(code) ||
      null;
    if (matchedProduct) break;
  }

  const productcode =
    item?.productcode ||
    matchedProduct?.productcode ||
    matchedProduct?.supproductcode ||
    "";
  const productname =
    item?.productname ||
    matchedProduct?.productname ||
    matchedProduct?.itemname ||
    matchedProduct?.itemdescription ||
    "";
  const immeasuringunit =
    item?.immeasuringunit ||
    matchedProduct?.immeasuringunit ||
    matchedProduct?.unitmeasure ||
    "";

  const returnedqty = Number(item?.returnedqty || 0);
  const acceptedqty =
    parseNumber(item?.acceptedqty) ??
    parseNumber(matchedProduct?.acceptedqty) ??
    parseNumber(matchedProduct?.receivedqty) ??
    0;

   const totalReturnedQtyForProduct = Array.isArray(grnReturnList)
  ? grnReturnList
      .filter(
        (r) =>
          String(r.sts) === CON_STATUS_RETURNAPPROVED &&          // ← add this condition
          (
            String(r?.productcode) === String(item?.productcode) ||
            String(r?.supproductcode) === String(item?.supproductcode)
          )
      )
      .reduce((sum, r) => sum + Number(r?.returnedqty ?? 0), 0)
  : Number(item?.returnedqty || 0);

  // Use unitprice from GRN products data for display (as per user requirement: "unitprice" = Unit Price)
  // Prioritize unitprice from matchedProduct (GRN products), then item data
  const unitprice = parseNumber(matchedProduct?.unitprice) ?? 
    parseNumber(item?.unitprice) ?? 0;

  // Use taxrate directly from API
  const taxrate = parseNumber(item?.taxrate) ?? 
    parseNumber(matchedProduct?.taxrate) ?? 0;

  // Use taxperunit directly from API first (as per user requirement: "taxperunit" = Tax Amount Per Unit)
  // Only calculate if API value is not available
  const taxPerUnit = parseNumber(item?.taxperunit) ?? 
    parseNumber(item?.perunittaxvalue) ?? 
    parseNumber(matchedProduct?.taxperunit) ?? 
    parseNumber(matchedProduct?.perunittaxvalue) ?? 
    (unitprice && taxrate ? (unitprice * taxrate) / 100 : 0);

  const beforeTaxFromItem =
    parseNumber(item?.totalbeforetax) ??
    parseNumber(item?.totaftertaxamount);
  const calculatedBeforeTax = unitprice * returnedqty;
  const totalBeforeTax =
    beforeTaxFromItem !== null
      ? beforeTaxFromItem
      : Number.isFinite(calculatedBeforeTax)
      ? calculatedBeforeTax
      : 0;

  const taxAmountFromItem = parseNumber(item?.taxamount);
  const calculatedTaxAmount = taxPerUnit * returnedqty;
  const taxAmount =
    taxAmountFromItem !== null
      ? taxAmountFromItem
      : Number.isFinite(calculatedTaxAmount)
      ? calculatedTaxAmount
      : 0;

  const totalAfterTaxFromItem = parseNumber(item?.totaftertaxamount);
  const computedTotalAfterTax = totalBeforeTax + taxAmount;
  const totalAfterTax =
    totalAfterTaxFromItem !== null
      ? totalAfterTaxFromItem
      : Number.isFinite(computedTotalAfterTax)
      ? computedTotalAfterTax
      : 0;

  const reason = item?.reason || item?.descrip || "";
  const remarks = item?.remarks || "";
  const attachmentName =
    item?.dtoDOCs?.[0]?.filename || item?.dtoDOCs?.[0]?.FILENAME || "";

  return {
    ...item,
    idno: index + 1,
    productcode,
    productname,
    immeasuringunit,
    unitprice,
    receivedqty: acceptedqty,
    returnedqty : totalReturnedQtyForProduct,
    taxrate,
    taxvalue: taxPerUnit,
    taxAmount,
    total_price: totalAfterTax,
    totalAmount: taxAmount,
    totalAfterTax,
    reason,
    remarks,
    attachmentName,
    id: productcode || item?.id || index,
  };
});

const grnItemsColumns = [
  { field: "idno", headerName: "No" },
  { field: "productcode", headerName: "Item Code" },
  { field: "productname", headerName: "Item Name" },
  { field: "immeasuringunit", headerName: "UOM" },
  { field: "receivedqty", headerName: "Total Quantity" },
  { field: "returnedqty", headerName: "Returned Quantity" },
  { field: "unitprice", headerName: "Unit Cost", format: formatCurrency },

  // { field: "reason", headerName: "Reason" },
  // { field: "remarks", headerName: "Remark" },
  // { field: "attachmentName", headerName: "Attachment" },
  {
    field: "taxrate",
    headerName: "Tax Rate(%)",
    format: (value) => (value ? `${value}%` : "0%"),
  },
  {
    field: "taxvalue",
    headerName: "Tax Amount Per Unit",
    format: formatCurrency,
  },
  {
    field: "taxAmount",
    headerName: "Tax Amount",
    format: formatCurrency,
  },
  {
    field: "total_price",
    headerName: "Total Price",
    format: formatCurrency,
  },
];





  const summarySet =
    Array.isArray(latestReturncalEntry?.grnReturnSummaries) &&
    latestReturncalEntry.grnReturnSummaries.length > 0
      ? latestReturncalEntry.grnReturnSummaries
      : [];
  const summaryEntry =
    summarySet.length > 0 ? summarySet[summarySet.length - 1] : null;

  // Also check if latestReturnMaster has grnReturnSummaries
  const masterSummarySet =
    Array.isArray(latestReturnMaster?.grnReturnSummaries) &&
    latestReturnMaster.grnReturnSummaries.length > 0
      ? latestReturnMaster.grnReturnSummaries
      : [];
  const masterSummaryEntry =
    masterSummarySet.length > 0 ? masterSummarySet[masterSummarySet.length - 1] : null;

  // Use API summary values with requested mapping
  // TOTAL BEFORE TAX = "tottaxableamount"
  // TOTAL TAX = "tottaxamount"
  // TOTAL = "totaftertaxamount"
  const apiReturnSummary = summaryEntry || masterSummaryEntry || {};

  const rowTotalBeforeTax = grnItemsRows?.reduce(
    (sum, item) => sum + (Number(item.total_price) || 0),
    0
  );

  const rowTotalTax = grnItemsRows?.reduce(
    (sum, item) => sum + (Number(item.taxAmount) || 0),
    0
  );

  const rowGrandTotal = rowTotalBeforeTax + rowTotalTax;

  // TOTAL BEFORE TAX = "totalbeforetax" from process API summary. Else grnReturnMaster, else rows fallback
 const finalTaxableAmount = approvedReturnMasters.length > 0
  ? approvedReturnMasters.reduce((sum, r) => sum + Number(r.tottaxableamount || 0), 0)
  : (apiReturnSummary?.totalbeforetax != null
      ? Number(apiReturnSummary.totalbeforetax)
      : rowTotalBeforeTax);

const finalTaxAmount = approvedReturnMasters.length > 0
  ? approvedReturnMasters.reduce((sum, r) => sum + Number(r.tottaxamount || 0), 0)
  : (apiReturnSummary?.tottaxamount != null
      ? Number(apiReturnSummary.tottaxamount)
      : rowTotalTax);

const finalTotal = approvedReturnMasters.length > 0
  ? approvedReturnMasters.reduce((sum, r) => sum + Number(r.totaftertaxamount || 0), 0)
  : (apiReturnSummary?.totreturnedvalue != null
      ? Number(apiReturnSummary.totreturnedvalue)
      : rowGrandTotal);
  const poData = grnHeader || grnDetailsForm || {};

  // Map API fields to UI fields with fallback keys for old data
  const poNumber =
    poData.ponumber === "0"
      ? poData.pocode
      : poData.ponumber || poData.poNumber || poData.pocode || "N/A";

  const poDate = poData.podate || poData.poDate || null;
  const invoiceNumber = poData.invoiceno || poData.invoiceNumber || "N/A";
  const invoiceDate = poData.invoicedate || poData.invoiceDate || null;
  const deliveryNoteNumber =
    poData.deliverynoteno || poData.deliveryNoteNumber || "N/A";
  const deliveryDate =
    poData.deliverynotedate || poData.deliverynotedate || null;

  const companyName = grnCompany?.compname || "N/A";
  const address1 = grnCompany?.compaddresS1 || "";
  const address2 = grnCompany?.compaddresS2 || "";
  const address3 = grnCompany?.compaddresS3 || "";
  const city = grnCompany?.city || "";
  const province = grnCompany?.province || "";
  const country = grnCompany?.country || "";
  const fullAddress = [address1, address2, address3, city, province, country]
    .filter(Boolean)
    .join(", ");

  const contact = grnCompany?.hotline || "N/A";
  const email = grnCompany?.email || "N/A";
  return (
    <div ref={printRef} id="print-section">
         <ThemeProvider theme={lightTheme}>
      <Box sx={{ maxWidth: 794, mx: "auto", p: 3, bgcolor: "white" }}>
        <GrnPdfHeader
          docType={docType}
          grnHeader={grnHeader}
          grnCompany={grnCompany}
          handlePrint={handlePrint}
        />

        <Divider sx={{ borderColor: "#2a6db0", mb: 4 }} />
        <Box
          mb={4}
          sx={{
            color: "black",
          }}
        >
          {/* <Typography variant="subtitle_s" component="span" fontWeight="bold">
            RETURN NOTE NUMBER:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {grnHeader?.grncode || "N/A"}
          </Typography>
          <br />
          <Typography variant="subtitle_s" component="span" fontWeight="bold">
            DATE:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {FormatDate(poDate) || "-"}
          </Typography>
          <br /> */}
           <Typography variant="body_xs" component="span" fontWeight="bold">
                        RETURN NOTE NO:
                      </Typography>{" "}
                      <Typography variant="body_xs" component="span">
                        {GenerateNoteNumber(CON_NOTE_RETURN,FormatDateYYYYMM(invoiceDate), poData?.grncode)}
                      </Typography>
                      <br />
                      <Typography variant="body_xs" component="span" fontWeight="bold">
                      RETURN NOTE DATE:
                      </Typography>{" "}
                      <Typography variant="body_xs" component="span">
                        {FormatDate(invoiceDate) || "-"} 
                      </Typography>
                      <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            INVOICE NUMBER:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {invoiceNumber}
          </Typography>
          <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            INVOICE DATE:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {FormatDate(invoiceDate) || "-"}
          </Typography>
          <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            GRN ID:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {grnHeader?.grncode || "N/A"}
          </Typography>
          <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            GRN DATE:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {FormatDate(poDate) || "-"}
          </Typography>
          <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            PO NUMBER:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {poNumber}
          </Typography>
          <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            PO DATE:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {FormatDate(poDate) || "-"}
          </Typography>
          <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            DELIVERY NOTE NUMBER:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
      {poData?.deliverynoteno ||  "-"}
          </Typography>
          <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            DELIVERY DATE:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {FormatDate(deliveryDate) || "-"}
          </Typography>
        </Box>

        <Box sx={styles.sup_buy_container}>
       <Box sx={styles.sup_buy_container_inside} mt={2}>
      <Typography
        variant="subtitle_s"
        fontWeight="bold"
        mb={1}
        sx={{ textTransform: "uppercase" }}
      >
        BUYER INFORMATION
      </Typography>

<TableContainer component={Paper} >
          <Table size="small" sx={{ "& td, & th": { borderBottom: "none", } }}>
          <TableBody>
            <TableRow>
              <TableCell >
                   <Typography variant="body_xs" component="span" fontWeight="bold">   COMPANY NAME</Typography>
              
              </TableCell>
              <TableCell>
                  <Typography variant="body_xs" component="span" >{companyName || "N/A"}</Typography></TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>
                  <Typography variant="body_xs" component="span" fontWeight="bold">ADDRESS</Typography></TableCell>
              <TableCell> <Typography variant="body_xs" component="span" >{fullAddress || "N/A"}</Typography></TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>
                 <Typography variant="body_xs" component="span" fontWeight="bold">CONTACT / PHONE</Typography></TableCell>
              <TableCell><Typography variant="body_xs" component="span" >{contact || "N/A"}</Typography></TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>
                
                 <Typography variant="body_xs" component="span" fontWeight="bold">EMAIL</Typography></TableCell>
              <TableCell>   <Typography variant="body_xs" component="span" >{email || "N/A"}</Typography></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
          <Box sx={styles.sup_buy_container_inside}>
            <GrnPdfSupplier
              grnHeader={grnHeader}
              selectedSupplier={selectedSupplier}
            />
          </Box>
        </Box>

        <ViewDataGridPdf
          // columns={ViewReturnNotePdfData.columns}
          columns={grnItemsColumns}
          // rows={rows}
          // rows={filteredRows.map((item) => ({ ...item, id: item.field }))}
          rows={grnItemsRows}
          // menuItems={menuItems}
          // tabletitle={ViewInitiatorGrnData.name}
          gridid="productcode"
          sx={styles.view_data_grid_page}
        />
        <Box
          display="flex"
          justifyContent="flex-end"
          mt={2}
          maxWidth={300}
          ml="auto"
        >
          <TableContainer component={Paper} sx={{ border: "1px solid black" }}>
            <Table size="small" sx={{ borderCollapse: "collapse" }}>
              <TableBody>
                {/* <TableRow>
                  <TableCell sx={cellStyleLabel}>TOTAL ITEMS</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {grnItemsRows.length}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyleLabel}>TOTAL GROSS</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(
                      summary.totgross || grnData.billings?.totalGross
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyleLabel}>PRODUCT DISCOUNT</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(
                      summary.totproductdiscount ||
                        grnData.billings?.productdiscountAmount
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyleLabel}>TAX</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(
                      summary.tottax || grnData.billings?.vatAmount
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyleLabel}>PENALTY</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(summary.totpenalty)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={cellStyleLabel}>NET TOTAL</TableCell>
                  <TableCell sx={{ ...cellStyleValue, fontWeight: "bold" }}>
                    {formatCurrency(
                      summary.totinvoice || grnData.billings?.finalInvoiceValue
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={cellStyleLabel}>TOTAL INVOICE</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(
                      summary.totinvoice || grnData.billings?.netValue
                    )}
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell sx={cellStyleLabel}> TOTAL  BEFORE TAX</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {
                      formatCurrency(finalTaxableAmount)

                      // Sub Total
                    }
                  </TableCell>
                </TableRow>
                    <TableRow>
                  <TableCell sx={cellStyleLabel}>TOTAL TAX</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {
                      formatCurrency(finalTaxAmount)

                      // Sub Total
                    }
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={cellStyleLabel}>TOTAL</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(finalTotal)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {/* <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="body_xs">
          <strong> Reason for Issuance:</strong>
        </Typography>
        <Typography variant="body_xs">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          aliquet ullamcorper auctor. Nunc tellus massa, condimentum a bibendum
          a, vestibulum eu dolor.
        </Typography>
      </Box> */}
        <GrnPdfInfo grnHeader={grnHeader} />

        {/* <GrnPdfNotes /> */}
        <GrnPdfFooter />
      </Box>
      </ThemeProvider>
    </div>
  );
}

export default ReturnNotePdfHistory;
